import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios"; // axios instance

export default function CheckoutPage() {
  const [cartItems, setCartItems] = useState([]);
  const [total, setTotal] = useState(0);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const existentUser = localStorage.getItem("customerInfo");

  const [isNewuser, setIsNewuser] = useState(null);
  const [useExistingAddress, setUseExistingAddress] = useState(false);
  const [isd, setIsd] = useState(["+91", "+1", "+44", "+49", "+61", "+81"]);
  const [selectedIsd, setSelectedIsd] = useState("+91");
const [existAddress, setExistAddress] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    zip: "",
    paymentMethod: "cod",
  });

  const [order, setOrder] = useState(null);
  const [otp, setOtp] = useState("");
  const [showOtpBox, setShowOtpBox] = useState(false);


  useEffect(() => {
  const stored = localStorage.getItem("customerInfo");
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      setIsNewuser(parsed.existing); // if existing=true → isNewuser=false

    } catch (e) {
      console.error("Failed to parse customerInfo", e);
    }
  }
}, []);

// Check if user is new or existing

  // Fetch cart items
  useEffect(() => {
    const fetchCart = async () => {
      if (token) {
        try {
          const res = await axios.get("/cart", {
            headers: { Authorization: `Bearer ${token}` },
          });
          setCartItems(res.data);
          const sum = res.data.reduce(
            (acc, item) => acc + item.price * item.quantity,
            0
          );
          setTotal(sum);
        } catch (error) {
          console.error("Failed to fetch cart", error);
        }
      } else {
        const guestCart = JSON.parse(localStorage.getItem("cart")) || [];
        setCartItems(guestCart);
        const sum = guestCart.reduce(
          (acc, item) => acc + item.price * item.quantity,
          0
        );
        setTotal(sum);
      }
    };
    fetchCart();
  }, [token]);

  // Prefill form if existing customer
useEffect(() => {
  if (existentUser) {
    const customer = JSON.parse(existentUser);
    if (customer.addresses && customer.addresses.length > 0) {
      const firstAddress = customer.addresses[0]; // ✅ pick first address
      setFormData((prev) => ({
        ...prev,
        fullName: firstAddress.name || prev.fullName,
        email: customer.email || prev.email,
        phone: customer.phone || prev.phone,
        address: firstAddress.address || prev.address,
        city: firstAddress.city || prev.city,
        state: firstAddress.state || prev.state, // include state if needed
        zip: `${firstAddress.zip}` || prev.zip,
      }));
      console.log("Prefilled Form Data:", typeof (firstAddress.zip));
    }
  }
}, [existentUser]);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("Submitting Order with Data:", cartItems.map(i => ({id: i.product_id , qty: i.quantity})), token);
      const orderItems = cartItems.map((item) => {
        if (token) {
          return { product_id: item.product.id, quantity: item.quantity };
        } else {
          return { product_id: item.product_id, quantity: item.quantity };
        }
      });

      const orderData = {
        items: orderItems,
        payment_method: formData.paymentMethod,
        total_price: total,
        full_name: formData.fullName,
        email: formData.email,
        phone: selectedIsd + formData.phone,
        address: formData.address,
        city: formData.city,
        zip: formData.zip,
      };
     
      const response = await axios.post(
        "/orders",
        orderData,
        token ? { headers: { Authorization: `Bearer ${token}` } } : {}
      );

      if (response.data.order) {
        const order = response.data.order;
        // Save customer info locally
        const addresses = existentUser
          ? Array.from(
              new Set([
                ...JSON.parse(existentUser).addresses,
                formData.address,
              ])
            )
          : [formData.address];
        localStorage.setItem(
          "customerInfo",
          JSON.stringify({
            existing: true,
            fullName: formData.fullName,
            email: formData.email,
            phone: selectedIsd + formData.phone,
            city: formData.city,
            zip: formData.zip,
            addresses,
          })
        );

        if (orderData.payment_method === "cod" && order.status === "otp_pending") {
          setOrder(order);
          setShowOtpBox(true);
          alert("Order placed! OTP sent for verification.");
        } else {
          alert("✅ Order placed successfully!");
          navigate("/thank-you");
        }
      } else {
        alert("Something went wrong.");
      }
    } catch (error) {
      alert(error.response?.data?.message || "❌ Failed to place order");
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      alert("❌ Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      await axios.post(`/orders/${order.id}/verify-otp`, { otp: otp.toString() });
      alert("🎉 Order verified successfully!");
      setShowOtpBox(false);
      navigate("/thank-you");
      window.location.reload();
    } catch (error) {
      alert(error.response?.data?.message || "❌ Something went wrong");
    }
  };
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Checkout</h2>

      {isNewuser ? (
        <div style={{ marginBottom: "10px" }}>
          <button type="button" onClick={() => (setUseExistingAddress(true), setExistAddress(true))}>
            Use Existing Address
          </button>
    <button
  type="button"
  onClick={() => {
    setUseExistingAddress(false);
    setExistAddress(false);
    setFormData((prev) => ({
      ...prev,
      fullName: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      state: "",
      zip: "",
    }));
  }}
>
  Use New Address
</button>

        </div>
      ) : ''}

      <div style={styles.layout}>
        {/* Cart */}
        <div style={styles.cart}>
          <h3>Your Cart</h3>
          {cartItems.map((item, idx) => (
            <div key={idx} style={styles.cartItem}>
              <div>{token ? item.product.name : item.name} (x{item.quantity})</div>
              <div>
                ₹
                {token
                  ? item.price * item.quantity
                  : item.price * item.quantity}
              </div>
            </div>
          ))}
          <hr />
          <div style={styles.total}>
            <strong>Total:</strong> ₹{total}
          </div>
        </div>

        {/* Checkout Form */}
        {!showOtpBox ? (
          useExistingAddress && existentUser ? (
            <div>
              {JSON.parse(existentUser).addresses.map((address, idx) => (
                <div
                  key={idx}
                  style={{ border: "1px solid #ccc", padding: "10px", marginBottom: "10px" }}
                >
                  <p><strong>Address:</strong> {address.address}, {address.city}, {address.zip}</p>

                  <button
  type="button"
  style={styles.button}
  onClick={() => {
    setFormData((prev) => ({
      ...prev,
      fullName: address.name || prev.fullName,
      email: JSON.parse(existentUser).email || prev.email,
      phone: JSON.parse(existentUser).phone || prev.phone,
      address: address.address || prev.address,
      city: address.city || prev.city,
      state: address.state || prev.state,
      zip: address.zip || prev.zip,
    }));
    setUseExistingAddress(false);
  }}
>
  Use This Address
</button>

                </div>
              ))}
            </div>
          ) : (
            <form style={styles.form} onSubmit={handleSubmit}>
              <h3>Billing & Shipping</h3>
              <input
                type="text"
                name="fullName"
                className="form-control"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
                readOnly={existAddress}
                required
              />
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                readOnly={existAddress}
                required
              />
              <div className="row">
                <div className="col-3">
                  <select
                    name="isd"
                    id="isd"
                    value={selectedIsd}
                    onChange={(e) => setSelectedIsd(e.target.value)}
                    className="form-control"
                    required
                    readOnly={existAddress}
                  >
                    {isd.map((code) => (
                      <option key={code} value={code}>{code}</option>
                    ))}
                  </select>
                </div>
                <div className="col-9">
                  <input
                    type="text"
                    className="form-control"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    readOnly={existAddress}
                    required
                  />
                </div>
              </div>
              <input
                type="text"
                name="address"
                className="form-control"
                placeholder="Address"
                value={formData.address}
                onChange={handleChange}
                readOnly={existAddress}
                required
              />
              <input
                type="text"
                name="city"
                className="form-control"
                placeholder="City"
                value={formData.city}
                onChange={handleChange}
                readOnly={existAddress}
                required
              />
              <input
                type="text"
                name="zip"
                className="form-control"
                placeholder="ZIP Code"
                value={formData.zip}
                onChange={handleChange}
                readOnly={existAddress}
                required
              />

              <h4>Payment Method</h4>
              <label>
                <input
                  type="radio"
                  name="paymentMethod"
                  value="cod"
                  checked={formData.paymentMethod === "cod"}
                  onChange={handleChange}
                />{" "}
                Cash on Delivery
              </label>
              <label>
                <input
                  type="radio"
                  name="paymentMethod"
                  value="card"
                  checked={formData.paymentMethod === "card"}
                  onChange={handleChange}
                />{" "}
                Credit/Debit Card
              </label>

              <button type="submit" style={styles.button}>
                Place Order
              </button>
            </form>
          )
        ) : (
          <div style={styles.form}>
            <h3>Verify Your Order</h3>
            <p>We sent an OTP to your email/phone. Please enter it below:</p>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button style={styles.button} onClick={handleVerifyOtp}>
              Verify OTP
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: "900px", margin: "0 auto", padding: "20px", fontFamily: "Arial" },
  heading: { textAlign: "center", marginBottom: "20px" },
  layout: { gap: "20px" },
  cart: { border: "1px solid #ccc", borderRadius: "8px", padding: "15px", background: "#f9f9f9" },
  cartItem: { display: "flex", justifyContent: "space-between", marginBottom: "10px" },
  total: { display: "flex", justifyContent: "space-between", fontSize: "1.2rem" },
  form: { display: "flex", flexDirection: "column", gap: "10px", border: "1px solid #ccc", padding: "15px", borderRadius: "8px" },
  button: { padding: "10px", background: "#28a745", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" },
};
